// Set up your root reducer here...
import { combineReducers } from 'redux'

import userDataReducer from './userDataReducer'
import trainingsReducer from './trainingsReducer'
import filtersReducer from './filtersReducer'
import eventReducer from './eventReducer'
import organisationStaffReducer from './Organisation/organisationStaffReducer'
import organisationShopReducer from './Organisation/organisationShopReducer'
import neighbourhoodPerksReducer from './Organisation/neighbourhoodPerksReducer'
import clientsReducer from './clientsReducer'
import communicationPortalReducer from './communicationPortalReducer'
import surveyReducer from './surveyReducer'
import checklistsReducer from './Organisation/checklistsReducer'
import formReducer from './formReducer'
import buildingAnalyticsReducer from './buildingAnalyticsReducer'
import shopReducer from './shopReducer'
import serviceFormReducer from './serviceFormReducer'
import maintenanceReducer from './maintenanceReducer'
import maintenanceStaffReducer from './maintenanceStaffReducer'
import organisationManagersReducer from './Organisation/organisationManagersReducer'
import propertyManagersReducer from './Organisation/propertyManagersReducer'
import shiftManagersReducer from './Organisation/shiftManagersReducer'
import chatReducer from './chatReducer'
import bookTypesReducer from './Organisation/bookTypesReducer'
import bookCategoriesReducer from './Organisation/bookCategoryReducer'
import reservationsReducer from './Organisation/reservationsReducer'
import packagesReducer from './Organisation/packagesReducer'
import groupsReducer from './Organisation/groupsReducer'
import guestsReducer from './guestsReducer'
import rewardsReducer from './rewardsReducer'
import buildingSelectorReducer from './buildingSelectorReducer'
import valetReducer from './Organisation/valetReducer'
import parkingStaffReducer from './Organisation/parkingStaffReducer'
import parkingReducer from './parkingReducer'
import loyaltyReducer from './loyaltyReducer'
import { inspectionsReducer } from './inspectionsReducer'
import reputationManagementReducer from './reputationManagementReducer'

const rootReducer = combineReducers({
  buildingAnalytics: buildingAnalyticsReducer,
  userData: userDataReducer,
  trainings: trainingsReducer,
  filters: filtersReducer,
  event: eventReducer,
  organisationStaff: organisationStaffReducer,
  organisationManagers: organisationManagersReducer,
  propertyManagers: propertyManagersReducer,
  shiftManagers: shiftManagersReducer,
  valet: valetReducer,
  parkingStaff: parkingStaffReducer,
  chat: chatReducer,
  organisationShop: organisationShopReducer,
  organisationPlaces: neighbourhoodPerksReducer,
  clients: clientsReducer,
  communicationPortal: communicationPortalReducer,
  survey: surveyReducer,
  checklistsHistory: checklistsReducer,
  shop: shopReducer,
  form: formReducer,
  bookTypes: bookTypesReducer,
  bookCategories: bookCategoriesReducer,
  serviceForm: serviceFormReducer,
  maintenance: maintenanceReducer,
  staff: maintenanceStaffReducer,
  reservations: reservationsReducer,
  packages: packagesReducer,
  groups: groupsReducer,
  guests: guestsReducer,
  rewards: rewardsReducer,
  buildingSelector: buildingSelectorReducer,
  parking: parkingReducer,
  loyalty: loyaltyReducer,
  inspections: inspectionsReducer,
  reputationManagement: reputationManagementReducer,
})

export default rootReducer
